import listSaga from './listSaga'
import createSaga from './createSaga'
import companyList from './companyListSaga'
import declineQuotations from './decline'
import closeQuotations from './close'
import staticEnumsSaga from './staticEnumsSaga'
import oneQuotationSaga from './oneQuotationSaga'
import createCustomSaga from './createCustomSaga'

const quotationsSagas = [
    listSaga(),
    createSaga(),
    companyList(),
    declineQuotations(),
    closeQuotations(),
    staticEnumsSaga(),
    oneQuotationSaga(),
    createCustomSaga()
]

export default quotationsSagas
